module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mod-selling red"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "swipe-optim"
  }, [_c('div', {
    staticClass: "swipe-wrap"
  }, [_c('div', {
    staticClass: "swipe",
    attrs: {
      "id": "swipe-optim-content"
    }
  }, [_c('Carousel', {
    attrs: {
      "autoplay": _vm.setting.autoplay,
      "autoplay-speed": _vm.setting.autoplaySpeed,
      "dots": _vm.setting.dots,
      "radius-dot": _vm.setting.radiusDot,
      "trigger": _vm.setting.trigger,
      "arrow": _vm.setting.arrow,
      "height": 480
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.list), function(ch) {
    return _c('CarouselItem', {
      key: ch.key
    }, _vm._l((ch.children), function(item, index) {
      return _c('router-link', {
        key: item.aid,
        staticClass: "goods-item",
        attrs: {
          "to": item.url,
          "target": "_blank"
        }
      }, [_c('img', {
        staticClass: "img-item",
        attrs: {
          "src": item.atturl,
          "alt": item.aname
        }
      })])
    }), 1)
  }), 1)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "mod-selling-title"
  }, [_c('span', [_vm._v("精品直降")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6432105c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/self-owned-mall/index/boutique-discount.vue
// module id = 1619
// module chunks = 1